import { memo } from "react";
import { Button, Space, Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { mdlParameter } from "../../models/domain/Parameter";
import { enmParameterType } from "../../models/enums/ParameterDataType";

export type ParameterTableProps = {
    dataSource?: mdlParameter[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
}

export const ParameterTable = memo(function ParameterTable(props: ParameterTableProps) {
    const { t } = useTranslation();



    const getValueString = (val: any, dtype: enmParameterType): string => {
        if (val == null) val = "";
        switch (dtype) {
            case enmParameterType.TEXT:
            case enmParameterType.TEXTAREA:
                return val ? val.toString() : "";
            case enmParameterType.CHECKBOX:
                return val == "TRUE" ? t("common.yes") : t("common.no");
            case enmParameterType.SELECT:
                switch (val) {
                    case "tr-TR":
                        return t("language.turkish");
                    case "en-US":
                        return t("language.english");
                    case "bg-BG":
                        return t("language.bulgarian");
                    case "0":
                        return t("common.none");
                    default:
                        const parsed = parseInt(val, 10);
                        return !isNaN(parsed) ? `${parsed} ${t("common.hour")}` : val.toString();
                }
            default:
                return '';
        }
    };

    const columns: TableProps<mdlParameter>['columns'] = [
        {
            title: t("parameters.parameterName"),
            dataIndex: 'parameterDesc',
            key: 'parameterDesc'
        },
        {
            title: t("parameters.value"),
            dataIndex: 'value1',
            key: 'value1',
            render: (_, record) => (
                <>
                    {record.value1 ?
                        getValueString(record.value1, record.parameterDataType) :
                        `${getValueString(record.defaultValue, record.parameterDataType)} (${t("common.default")})`
                    }
                </>
            ),
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" className="btn-success" onClick={() => props.onEdit ? props.onEdit(record) : undefined}>
                        {t("common.edit")}
                    </Button>
                </Space>
            ),
        },
    ];

    const handleTableChange: TableProps<mdlParameter>['onChange'] = (pagination, filters) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
            {props.dataSource && (
                <Table<mdlParameter>
                    className="mt-2"
                    onChange={handleTableChange}
                    size="middle"
                    columns={columns}
                    pagination={props.pagination}
                    scroll={{ x: 'max-content' }}
                    dataSource={props.dataSource.map((customer: mdlParameter, index: number) => ({ ...customer, key: index }))}
                />
            )}
        </>
    );
});
